import { LifegridMark } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="relative border-t border-white/10 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-3">
          <LifegridMark size={26} />
          <div className="font-mono-tac text-[10px] tracking-[0.28em] text-[color:var(--lg-text-3)]">
            LIFEGRID // WHEN LIFE GOES WRONG, KNOW WHAT TO DO NEXT.
          </div>
        </div>
        <div className="font-mono-tac text-[10px] tracking-[0.28em] text-[color:var(--lg-text-3)]">
          PROTOTYPE · NOT A SUBSTITUTE FOR EMERGENCY SERVICES · © {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
}
